import { Text } from '@kanda-libs/ks-design-library';
import { MarkdownDisplay } from '@kanda-libs/ks-component-ts';

import Container from './Description-container';

import { SKELETONS } from '../../LineItem-constants';

const ViewComponent = ({}) => (
  <Container>
    {({ description, isLoading, classNames }) => (
      <Text
        className={classNames.description}
        isLoading={isLoading}
        text={<MarkdownDisplay>{description}</MarkdownDisplay>}
        skeletonProps={SKELETONS.description}
      />
    )}
  </Container>
);

ViewComponent.displayName = 'LineItem-Description-view';

export default ViewComponent;
